import * as types from '../../mutation-types.js';
import http from '@service/http';
import {
  tokenCall,
  restCall
} from '@service/adapter';
import util from '@common/utils/util';
import Constant from '@/Constant';
import {
  storage
} from "@common/utils/util.js";

/**
 *  STORE
 */
export default {
  state: {

  },
  actions: {
    //【工程评价】获取订单当前标志：1经销商 2工程师
    getOrderFlag({
      commit
    }, data) {
      return tokenCall(Constant.commentTokenCallUrl + '/comment/login/getOrderFlag', data).then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    //【经销商、工程师】手机号验证码登录
    loginByComment({
      commit
    }, data) {
      return tokenCall(Constant.commentTokenCallUrl + '/comment/login/loginByComment', data).then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    //【工程评价】获取订单信息
    getCpOrderInfo({
      commit
    }, data) {
      return tokenCall(Constant.commentTokenCallUrl + '/comment/api/comment/getCpOrderInfo', data).then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    //【工程评价】添加评价
    addEvalComment({
      commit
    }, data) {
      return tokenCall(Constant.commentTokenCallUrl + '/comment/api/comment/addEvalComment', data).then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    },
    //【评价】发送经销商或工程师 验证码
    sendCommentAuthCode({
      commit
    }, data) {
      return tokenCall(Constant.commentTokenCallUrl + '/comment/login/sendCommentAuthCode', data).then(res => {
        if (res.code == 200) {
          return Promise.resolve(res.data);
        } else {
          return Promise.reject(res || "获取数据失败");
        }
      }).catch(error => {
        return Promise.reject(error);
      })
    }
  },
  mutations: {

  },
  getters: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/afterSaleComment/index.js